import { JsonName, serialize } from 'tserialize';

export type TOrderCreateRequest = Omit<OrderCreateRequest, 'toServer'>;

export class OrderCreateRequest {
  /** ID способа оплаты
   * (1 - ЮKassa)
   */
  @JsonName('order[payment_method_id]') paymentMethodId!: number;

  /** Имя */
  @JsonName('user[name]') name!: string;

  /** Фамилия */
  @JsonName('user[last_name]') lastName!: string;

  /** Email */
  @JsonName('user[email]') email!: string;

  /** Телефон */
  @JsonName('user[phone]') phone!: string;

  /** Код доставки */
  @JsonName('order[shipping_type_code]') shippingTypeCode!: string;

  /** Страна доставки */
  @JsonName('shipping_address[country]') country!: string;

  /** Регион доставки */
  @JsonName('shipping_address[state]') state!: string;

  /** Город доставки */
  @JsonName('shipping_address[city]') city!: string;

  /** Улица, дом, квартира */
  @JsonName('shipping_address[address1]') address1!: string;

  /** Почтовый индекс */
  @JsonName('shipping_address[postcode]') postcode?: string;

  /** Комментарий */
  @JsonName('order[property][comment]') comment?: string;

  constructor(data: TOrderCreateRequest) {
    Object.assign(this, data);
  }

  toServer(): OrderCreateRequest {
    return serialize(this) as OrderCreateRequest;
  }
}
